export const scrollToViewStart = (element: string | HTMLElement, container: HTMLElement) => {
    const selectedElement =
        typeof element === 'string' ? (document.querySelector(element) as HTMLElement) : element;
    if (selectedElement) {
        const containerOffsetTop = container.getBoundingClientRect().top;
        const containerScroll = container.scrollTop;
        const elementPosition = selectedElement.getBoundingClientRect().top;

        container.scrollTo({
            top: containerScroll + elementPosition - containerOffsetTop,
            behavior: 'smooth'
        });
    }
};
